import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import doctorPills from 'public/doctor-pills.svg';

export const ShowDoctorCard = styled.div`
  display: flex;
  background: ${props => props.theme.colors.capsuleBlue50} !important;

  width: 32.7rem;
  height: 21rem;
  border-radius: ${props => props.theme.space.s3} !important;

  ${({ theme }) => theme.mediaQueries.smallDown} {
    width: 100%;
  }
`;

export const DoctorCardContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const DoctorCardLeftSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

export const DoctorCardRightSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const DoctorCardTitle = styled.div`
  width: 100%;
  margin-top: ${props => props.theme.space.s5} !important;
  margin-left: ${props => props.theme.space.s5} !important;
`;

export const DoctorCardAddress = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.space.s5} !important;
  margin-left: ${props => props.theme.space.s5} !important;
`;
export const DoctorCardButtonSection = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: ${props => props.theme.space.s3} !important;
  margin-right: ${props => props.theme.space.s5} !important;
`;

// Pill section using absolute position for SVG pills
export const InlineSVGDoctorCardPills = styled(InlineSVG).attrs({ src: doctorPills, 'aria-hidden': true })`
  display: block;
  position: absolute;
  width: 13rem;
  right: 0;
  top: 0;
  pointer-events: none;
`;

export const DoctorCardPhoneNumberContainer = styled.div`
  display: flex;
  justify-content: start;
  margin-top: ${props => props.theme.space['0.5']} !important;
`;

export const DoctorCardFaxNumberContainer = styled.div`
  display: flex;
  justify-content: start;
`;
